<template>
  <div class="h-screen overflow-hidden bg-gray-100 flex flex-col">
    <FlashMessage v-if="messages.text != ''" :message="messages" />
    <div
      v-if="certificate?.image"
      class="flex-1 flex items-center justify-center p-4"
      style="height: calc(100vh - 80px)"
    >
      <iframe
        :src="certificate.image"
        scrolling="no"
        class="border-0 bg-white shadow-xl rounded overflow-hidden"
        style="
          aspect-ratio: 1918 / 1356;
          width: min(100%, calc((100vh - 200px) * 1918 / 1356));
        "
        title="Certificate"
      ></iframe>
    </div>
    <div
      v-if="certificate?.image"
      class="fixed bottom-0 left-0 right-0 h-20 flex items-center justify-center"
    >
      <button
        type="button"
        :disabled="downloading"
        class="bg-[#0085DB] hover:bg-blue-600 text-white rounded-lg text-sm font-semibold px-8 py-2.5 disabled:opacity-60"
        @click="downloadCertificate"
      >
        {{ downloading ? "Downloading..." : "Download Certificate" }}
      </button>
    </div>
    <p v-else-if="!loading" class="text-center text-gray-600 mt-20">
      Certificate not found
    </p>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: { FlashMessage },
  props: ["certificate_id"],
  data() {
    return {
      certificate: null,
      loading: true,
      downloading: false,
      messages: { text: "", type: "null" },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  async created() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API}/completed-certificates/?Key=${this.userInfo.token_key}&lesson_track__lesson_id__course_name__certificate_enable=true&lesson_track__user_id__id=${this.userInfo.user.id}&certificate_provide=true`,
      );
      this.certificate = (response.data.data || []).find(
        (c) => String(c.id) === String(this.certificate_id),
      );
    } catch (e) {
      console.error("Failed to load certificate:", e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async downloadCertificate() {
      console.log("Downloading certificate:", this.certificate.image);
      this.downloading = true;
      const fileName = `${(this.certificate.course_title || "certificate").replace(/\s+/g, "_")}_certificate.html`;
      try {
        const res = await fetch(this.certificate.image);
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Certificate download failed:", e);
        this.messages = {
          text: "Warning: certificate download failed. Please try again later.",
          type: "message",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "null" };
        }, 4000);
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>
